import api from '@/billing/API';

interface Promo {
  name: string,
  description: string,
  amount: number
}

interface Tax {
  abbrev: string,
  amount: number
}

export interface Price {
  currency: string,
  subTotal: number,
  promos: Promo[],
  discountedSubTotal: number,
  taxes: Tax[],
  total: number,
}

export function calculatePrice(customerId: number): Promise<Price> {
  return api
    .get(`customers/${customerId}/price`)
    .then(response => response.data);
}
